import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'
import {
  type GeofenceAreaListResponse,
  GeofenceAreaListResponseSchema,
  type GeofenceEventRequest,
  type GeofenceEventResponse,
  GeofenceEventResponseSchema,
} from '@/schemas/v2/geofence'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

/** 入退室メッセージ用の判定エリア一覧を取得する（GET /api/v2/geofence-areas・認証必須）。 */
export async function fetchGeofenceAreas(options?: FetchOptions): Promise<GeofenceAreaListResponse> {
  const url = `${BASE}/api/v2/geofence-areas`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return GeofenceAreaListResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

/** 入退室メッセージ表示履歴を記録する（POST /api/v2/geofence-areas/{id}/events）。 */
export async function recordGeofenceEvent(
  id: number,
  body: GeofenceEventRequest,
  options?: FetchOptions,
): Promise<GeofenceEventResponse> {
  const url = `${BASE}/api/v2/geofence-areas/${id}/events`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, body, options)
    return GeofenceEventResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
